export default __webpack_public_path__ + "static/media/Telegram.8b29d76d.svg";